var map = {
	"./agenda-una-reunion/op_img-header.png": 2673,
	"./como-funciona/op_img-header.png": 1426,
	"./nuestra-propuesta/op_img-header.png": 2674,
	"./politicas/op_img-header.png": 2675,
	"./preguntas-frecuentes/op_img-header.png": 2676,
	"./quienes-somos/op_img-header.png": 2677,
	"./registro/op_img-header.png": 2678,
	"./tratamiento-datos/op_img-header.png": 2679
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2672;